const DEFAULT_COORDINATE_PRECISION = 3;

export const formatElapsedMinutes = value => {
  const totalMinutes = Math.max(0, Math.floor(Number(value)));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${String(hours).padStart(2, '0')} h ${String(minutes).padStart(2, '0')}`;
};

const isFiniteCoordinate = value => Number.isFinite(Number(value));

const getCoordinateGroupKey = (agent, precision) => [
  Number(agent.latitude).toFixed(precision),
  Number(agent.longitude).toFixed(precision),
].join(':');

export const buildAgentLocationMarkerGroups = (agents = [], options = {}) => {
  const precision = options.precision === undefined
    ? DEFAULT_COORDINATE_PRECISION
    : options.precision;
  const groupsByCoordinate = new Map();

  agents.forEach(agent => {
    if (!isFiniteCoordinate(agent.latitude) || !isFiniteCoordinate(agent.longitude)) {
      return;
    }

    const key = getCoordinateGroupKey(agent, precision);

    if (!groupsByCoordinate.has(key)) {
      groupsByCoordinate.set(key, {
        id: `agent-location-${key}`,
        latitudeTotal: 0,
        longitudeTotal: 0,
        agents: [],
      });
    }

    const group = groupsByCoordinate.get(key);
    group.latitudeTotal += Number(agent.latitude);
    group.longitudeTotal += Number(agent.longitude);
    group.agents.push(agent);
  });

  return Array.from(groupsByCoordinate.values()).map(group => {
    const agentCount = group.agents.length;

    return {
      id: group.id,
      latitude: group.latitudeTotal / agentCount,
      longitude: group.longitudeTotal / agentCount,
      agents: group.agents,
      agentCount,
      isCluster: agentCount > 1,
    };
  });
};
